import * as React from 'react';
import { Dispatch } from 'redux';
import { connect } from 'react-redux';
const find = require('lodash.find');
const get = require('lodash.get');
const matchesProperty = require('lodash.matchesproperty');

import { PopularList } from '../../components/popular_list/popular_list';
import { ITopGroup, ITopThree } from '../../models/top_three';
import { setSaleGroupSelected } from '../../redux/modules/top_three';

import { trackPopularAds } from '../../helpers/metrics_helper';

interface IProps {
  id: string;
  title: string;
  groups: ITopGroup[];
  topThree: ITopThree;
  dispatch: Dispatch<any>;
}

class SalesBlock extends React.Component<IProps> {
  public componentWillMount() {
    this.props.dispatch(setSaleGroupSelected(this.props.groups[0].id));
  }

  public getOffers() {
    return get(find(
      this.props.groups,
      matchesProperty('id', this.props.topThree.groupSaleSelected)), 'offers', []);
  }

  public getProductData(group: string = this.props.topThree.groupSaleSelected) {
    return get(find(
      this.props.groups,
      matchesProperty('id', group)),
        'trackingProductData', []);
  }

  private onTabClick(eventLabel: string) {
    trackPopularAds(eventLabel, { impressions: this.getProductData(eventLabel) });
  }

  private onItemClick(order: number) {
    const products = this.getProductData();
    trackPopularAds(
      this.props.topThree.groupSaleSelected,
      {
        click: {
          actionField: {list: 'main_page'},
          products: (products.length > order) ? [products[order]] : [],
        },
      },
    );
  }

  public render() {
    return (<PopularList
                id={this.props.id}
                title={this.props.title}
                groups={this.props.groups}
                selectItem={(index: string) => this.props.dispatch(setSaleGroupSelected(index))}
                isItemSelected={(index: string) => (this.props.topThree.groupSaleSelected === index)}
                onTabClick={(eventLabel: string) => this.onTabClick(eventLabel)}
                onItemClick={(order: number) => this.onItemClick(order)}
                getOffers={() => this.getOffers()}
              />);
  }
}

const SalesBlockWrapper = connect<{}, {}, any>((state: IProps) => ({
  topThree: state.topThree,
}))(SalesBlock);

export { SalesBlockWrapper as SalesBlock, SalesBlock as SalesBlockClass };
